/**
 * RED-310 / RED-316 — readable text of one transactions-map filter
 * (`{ key, type, value, unit? }`), in the map's own field labels. Shared by the
 * Analüütika drawer's filter chips and its collapsed conditions line, so a
 * report names exactly the filters it ran with.
 *
 * `i18n` is the `{ t, te }` pair from `useI18n()`.
 */
export const mapFilterLabel = (key, { t, te }) => {
  const candidates = [
    `messages.transactions.analytics.form.filter_labels.${key}`,
    `messages.transactions.fields.${key}`,
    `messages.transactions.filters.${key}.label`,
  ]
  const hit = candidates.find(k => te(k))
  return hit ? t(hit) : key
}

export const mapFilterValue = (filter, { t }) => {
  const value = filter?.value
  switch (filter?.type) {
    case 'switch':
      return t('messages.transactions.analytics.form.filter_yes')
    case 'range':
    case 'area_range': {
      const [min, max] = Array.isArray(value) ? value : [null, null]
      const hasMin = min !== null && min !== undefined && min !== ''
      const hasMax = max !== null && max !== undefined && max !== ''
      const unit = filter.unit ? ` ${filter.unit}` : ''
      if (hasMin && hasMax) return `${min} – ${max}${unit}`
      if (hasMin) return `≥ ${min}${unit}`
      if (hasMax) return `≤ ${max}${unit}`
      return ''
    }
    default:
      return Array.isArray(value) ? value.join(', ') : String(value ?? '')
  }
}
